// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"db4f1ff7","453":"fd3d8d48","732":"846df843","977":"dd5045ca"}[chunkId] + ".chunk.js";
};